import { useDialog } from "@platform/store";
import { useOrgLookup } from "@platform/features/invitation/hooks/useOrgLookup";
import { OrgLookupDialog } from "./OrgLookupDialog";
import { OrgLookupItemContainer } from "./OrgLookupItem";

/**
 * Container component that handles business logic for OrgLookupDialog.
 * Manages dialog state and organization lookup.
 */
export function OrgLookupDialogContainer() {
  const { activeDialog, closeDialog } = useDialog();

  const isOpen = activeDialog === "orgLookup";

  const {
    handleClose,
    handleSelectOrganization,
    handleCreateOrganization,
    options,
    selectedOptions,
    selectedOrg,
    isLoading,
  } = useOrgLookup({
    onClose: () => closeDialog(),
    shouldLoad: isOpen,
  });

  return (
    <OrgLookupDialog
      isOpen={isOpen}
      options={options}
      selectedOptions={selectedOptions}
      selectedOrg={selectedOrg}
      isLoading={isLoading}
      onClose={handleClose}
      onSelectOrganization={handleSelectOrganization}
      onCreateOrganization={handleCreateOrganization}
      renderSelectedItem={(option) => (
        <OrgLookupItemContainer key={option.value} {...option} />
      )}
    />
  );
}

export default OrgLookupDialogContainer;

